<template lang="pug">
div(@dragend="dragend" @touchend="dragend").wrap-atom-asset-item.relative.w-full.h-full.rounded.cursor-pointer.mt4
  div.wrap-img.relative.w-full.h-full.f.fh.overflow-hidden
    img(:src="asset.mainImg").object-fit-cover.h-full
    div.wrap-actions.absolute.l0.b0.f.fm.px2.py2
      v-icon(@click.stop="onDelete" size="13" dark).mr1 mdi-delete
      v-icon(@click.stop="onDetail" size="13" dark) mdi-information
  div(v-if="loadingProgress").wrap-loading.absolute.l0.t0.w-full.h-full.f.fh.rounded
    div
      v-progress-circular(size="28" width="2"
        :color="pallete.$primary_bg_color" indeterminate)
        span.fz10 {{loadingProgress.progress}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$assets_window_width: 80px;
$assets_window_padding_size: 6px;
$asset_img_size: 68px;
.wrap-atom-asset-item {
  width: calc(#{$assets_window_width} - #{$assets_window_padding_size} * 2);
  height: calc(#{$assets_window_width} - #{$assets_window_padding_size} * 2);
  background: $secondary_bg_color;
  touch-action: none; // spでのドラッグ中のスクロールを禁止
  .wrap-img {
    overflow: hidden;
    img {
      max-height: $asset_img_size;
    }
    .wrap-actions {
      display: none;
    }
    &:hover {
      .wrap-actions {
        display: flex;
        background: $overlay_color;
        border-radius: 0 3px 0 3px;
      }
    }
  }
  .wrap-loading {
    background: $overlay_color;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
// const { mapActions: mapSctionsStudio } = createNamespacedHelpers('studio')

export default {
  props: {
    asset: { type: Object, required: true },
    type: { type: String, required: true },
    assetLoadingProgresses: { type: Array, required: true }
  },
  computed: {
    ...mapStateAuth(['uid']),
    loadingProgress () {
      return this.assetLoadingProgresses
        .filter(e => e.assetId === this.asset.id)[0]
    },
    path () {
      const assetId = this.asset.id ? this.asset.id : this.asset.objectID
      return `${window.location.origin}/asset/${assetId}`
    }
  },
  methods: {
    // ...mapSctionsStudio(['setDraggingAsset', 'resetDraggingAsset']),
    async dragend (e) {
      const event = e.changedTouches ? e.changedTouches[0] : e
      const endPos = { x: event.clientX, y: event.clientY }

      // assetManagerのウィンドウの範囲でドロップされたら入れ替えをする
      const assetManager = this.$parent.$parent
      const $assets_window_width = 80
      const $assets_window_padding_size = 6
      const $top_margin_size = 56
      if (endPos.x <= ($assets_window_width + $assets_window_padding_size)
        && endPos.y >= $top_margin_size
        && endPos.y <= ($top_margin_size + assetManager.$el.clientHeight)) {
        this.$emit('updateAssetOrder')
        return
      }
      console.log('dragend endPos:', endPos)

      this.$emit('dropObject', { asset: this.asset, dropPosition: endPos })
    },
    async onDelete () {
      const go = await window.customConfirm('このアセットを削除しますか？（コマ内に配置したオブジェクトも削除されます）')
      if (go) {
        this.$root.$emit('deleteAssetFromAssets', { 
          asset: this.asset
        })
      }
    },
    onDetail () {
      window.open(this.path, '_blank')
    }
  }
}
</script>
